import { normalizePostHogStackFilename } from './posthog-error-policy';

/** Public application assets are source locators; fingerprints normalize them
 * separately. Credentials, query strings and navigation paths never qualify. */
export function sanitizePostHogBrowserSourceFilename(value: string): string {
  try {
    const url = new URL(value);
    const isApplicationHost = [
      'imai.studio',
      'www.imai.studio',
      'beta.imai.studio',
      'dev.imai.studio',
    ].includes(url.hostname);
    if (
      url.protocol === 'https:' &&
      isApplicationHost &&
      !url.username &&
      !url.password &&
      !url.port &&
      url.pathname.startsWith('/_next/static/') &&
      /\.[cm]?js$/.test(url.pathname)
    ) {
      return `${url.origin}${url.pathname}`;
    }
  } catch {
    // Non-URL frames continue through the existing private-path sanitizer.
  }
  return normalizePostHogStackFilename(value);
}

export function isPostHogChunkId(value: unknown): value is string {
  return (
    typeof value === 'string' &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      value
    )
  );
}
